<style>
  .fast-slide-enter-active, .fast-slide-leave-active {
    transition: all 0.7s;
  }

  .fast-slide-enter, .fast-slide-leave-to {
    opacity: 0.8;
    transform: translateY(100%);
  }

  .fast-slide-leave-to {
    transition: all 0s;
  }

  div.placeholder {
    width: 100%;
    height: 0;
    background: #f7f7f7;
    position: relative;
  }

  img.placeholded-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

   #options_scroll_container {
    min-height: 90vh;
    max-height: 90vh;
    overflow: hidden;
  }

  #options_scroll_container .search-items {
    overflow: auto;
    max-height: calc(90vh - 70px);
  } 

      

</style>
<template>
  <div>
    <div class="search-line">
      <form style="display: block;" class="hl_search_form">
        <div class="hl_search_icon" @click="enable()"></div>
        <input :value="input" @focus="enable()" type="text" ref="search-input-line"
               :placeholder="text('search_placeholder')">
        <div class="hl_search_clear" @click="clear()"
             v-if="$store.getters.outletSettings.delivery_type !== 4"></div>
        <div class="hl_calendar" @click="openDateFilter()"
             v-if="$store.getters.outletSettings.delivery_type === 4">
          <svg
            :fill="$store.getters.filter.date.start !== null && $store.getters.filter.date.end !== null ? '#0084FF' : '#cccccc'"
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
              d="M12,19a1,1,0,1,0-1-1A1,1,0,0,0,12,19Zm5,0a1,1,0,1,0-1-1A1,1,0,0,0,17,19Zm0-4a1,1,0,1,0-1-1A1,1,0,0,0,17,15Zm-5,0a1,1,0,1,0-1-1A1,1,0,0,0,12,15ZM19,3H18V2a1,1,0,0,0-2,0V3H8V2A1,1,0,0,0,6,2V3H5A3,3,0,0,0,2,6V20a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V6A3,3,0,0,0,19,3Zm1,17a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V11H20ZM20,9H4V6A1,1,0,0,1,5,5H6V6A1,1,0,0,0,8,6V5h8V6a1,1,0,0,0,2,0V5h1a1,1,0,0,1,1,1ZM7,15a1,1,0,1,0-1-1A1,1,0,0,0,7,15Zm0,4a1,1,0,1,0-1-1A1,1,0,0,0,7,19Z"/>
          </svg>
        </div>
      </form>
    </div>
    <transition name="fade">
      <div :key="'options_dark'" class="pu_dark" v-show="$store.getters.modal.search"></div>
    </transition>
    <transition name="slide">
      <div class="search-block pu_bottom popup_click_hide" v-show="$store.getters.modal.search">
        <div class="pu_bottom_scroll" style="height: 90vh;">
          <div @click="disable()" class="pu_b_close"></div>
          <div class="pu_bottom_inner scroll_y" id="options_scroll_container">
                      <span class="input input_style">
                        <input :placeholder="text('search') + '...'" class="input__field input__field--ruri"
                               ref="search-input-block" type="text" v-model="input"
                        />
                      </span>

            <transition name="fast-slide">
              <div class="search-empty" v-if="!items.length">
                <img :src="require('@/assets/img/facebook/basket_none_ico.svg')" alt="empty"
                >
              </div>
            </transition>
            <div class="search-items" v-if="items.length">
              <div @click="found(product)" class="search-item"
                   style="margin: 10px 0; cursor: pointer"
                   v-for="product in items">

                <a
                  :class="{ 'tl_none': product.is_stopped || getCategory(product).work_time.is_working_now === false, 'tl_small_img': product.images.length > 0 }">

                  <div class="tl_img" v-if="product.images.length > 0">
                    <div :style="{ paddingTop: '100%' }" class="placeholder">
                      <img
                        :data-srcset="getImageUrl(product, IMAGE_TYPE_SPLASH) + ' 1x, ' + getImageUrl(product, IMAGE_TYPE_SPLASH_2X) + ' 2x'"
                        @load="setHeight" alt="" class="placeholded-image"
                        style="object-fit: cover;"
                        v-lazy="getImageUrl(product, IMAGE_TYPE_SPLASH)" width="100%">
                    </div>

                  </div>

                  <div class="tl_head">
                    <div class="tl_name">
                      {{product.name}} <span>{{ product.qty }}&nbsp;{{ product.qty_unit }}</span>
                    </div>
                    <template v-if="showDescription">
                      <div v-if="product.description.length > 0" class="tl_info">
                        {{product.description}}
                      </div>
                      <div class="fade" v-if="isLong(product)"></div>
                    </template>
                    <template>
                      <div class="tl_head_price" v-if="product.show_price" :class="{ 'ios-font': $store.getters.checkIos }">
                        {{$options.filters.toCurrency(product.price)}}
                      </div>
                    </template>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>

</template>

<script>
  import {SET_MODAL} from '@/store/mutations.type'

  let debounce = require('lodash.debounce')
  const marked = require('marked')
  import {mapGetters} from 'vuex'

  const renderer = {
    code(code, infostring, escaped) {
      return '<p>' + code + '</p>'
    }
  }

  marked.use({renderer})

  export default {
    name: 'Search',
    data() {
      return {
        input: '',
        items: [],

        IMAGE_TYPE_ORIGINAL: 0,
        IMAGE_TYPE_SPLASH: 1,
        IMAGE_TYPE_SPLASH_2X: 2,
        IMAGE_TYPE_LARGE: 3
      }
    },
    watch: {
      input: debounce(function () {
        this.search()
      }, 500)
    },
    methods: {
      clear() {
        this.input = ''
      },

      openDateFilter() {
        this.$store.commit(SET_MODAL, {modal: 'datefilter', status: true})
      },

      enable() {
        if (!this.$store.getters.modal.search) {
          this.$store.commit(SET_MODAL, {modal: 'search', status: true})
        }
        let input = this.$refs['search-input-block']
        if (input !== document.activeElement) {
          document.activeElement.blur()
          setTimeout(function () {
            input.focus()
          }, 0)
        }
      },

      disable() {
        this.$store.commit(SET_MODAL, {modal: 'search', status: false})
      },

      found(product) {
        this.disable()

        let level = 0
        this.$store.getters.categories.forEach((category) => {
          if (category.id === product.category_id) {
            level = category.level
          }
        })
        level++

        let element = document.querySelector('#product_' + product.id)
        this.$scrollTo(element, 200, {
          offset: -60 * level
        })
      },

      async search() {
        this.items = []

        if (!this.input.length) {
          return
        }

        let categories = this.$store.getters.categories
        let products = this.$store.getters.products
        let searchInput = this.input.toLowerCase()

        let foundCategories = []

        categories.forEach((category) => {
          if (category.name.toLowerCase().includes(searchInput)) {
            foundCategories.push(category.id)
          }
        })

        let foundProducts = []

        products.forEach((product) => {
          if (product.name.toLowerCase().includes(searchInput) || foundCategories.includes(product.category_id)) {
            foundProducts.push(product)
          }
        })

        this.items = foundProducts
      },

      getImageUrl(product, type) {
        let params = ''

        if (type === this.IMAGE_TYPE_ORIGINAL) {
          return product.images[0].original + params
        }
        if (type === this.IMAGE_TYPE_SPLASH) {
          return product.images[0].splash + params
        }
        if (type === this.IMAGE_TYPE_SPLASH_2X) {
          return product.images[0].splash_2x + params
        }
        if (type === this.IMAGE_TYPE_LARGE) {
          return product.images[0].large + params
        }
      },

      setHeight(event) {
        let image = event.target
        image.height = image.clientWidth
      },

      isLong(product) {
        if (product.images.length > 0) {
          return true
        }
      },

      renderDescription(description) {
        return marked(this.$options.filters.nl2br(description))
      },

      getCategory(product) {
        for (let i in this.$store.getters.categories) {
          if (product.category_id === this.$store.getters.categories[i].id) {
            return this.$store.getters.categories[i]
          }
        }
      }

    },

    computed: {
      ...mapGetters(
        ['priceOnPhoto', 'showDescription', 'imagesStyle', 'IMAGES_SQUARE_MINIATURE', 'IMAGES_SQUARE_LEFT', 'IMAGES_SQUARE_RIGHT', 'IMAGES_WIDE'])
    }
  }
</script>

<style scoped>

</style>
